import { cva } from 'class-variance-authority';

export const CardStyle = cva('flex max-h-[466px] w-full sm:w-[45%] sm:max-w-[334px]', {
  variants: {
    isFullCards: {
      true: 'lg:w-[31%] lg:max-w-[360px]',
      false: 'lg:max-w-[400px]',
    },
  },
});
